import { categories } from "@/mocks/categories";

export default function CategoryGallery() {
  return (
    <section className="w-full bg-background-50 px-6 md:px-10 py-16 md:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            <span className="text-primary-500">Curated</span> Category{" "}
            <span className="text-accent-500">Finds</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            Browse our handpicked <strong>pandabuyspreadsheet</strong> categories organized for effortless discovery
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <a
            href={categories[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="relative group overflow-hidden rounded-2xl h-[400px] md:h-[480px] cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Premium%20designer%20sneakers%20stylishly%20arranged%20on%20polished%20concrete%20floor%20with%20morning%20sunlight%2C%20luxury%20editorial%20photography%2C%20warm%20golden%20highlights%2C%20minimal%20industrial%20loft%20setting%2C%20clean%20sophisticated%20composition%2C%20textured%20shadows&width=900&height=1200&seq=gallery-shoes-v5&orientation=portrait"
              alt="Shoes pandabuyspreadsheet category"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-label tracking-wider">
                Shoes
              </span>
              <p className="mt-3 text-background-50 text-sm leading-relaxed max-w-xs">
                Premium sneakers, retro runners, and designer footwear curated in the pandabuyspreadsheet collection
              </p>
            </div>
          </a>

          <div className="grid grid-rows-2 gap-5">
            <a
              href={categories[1].url}
              target="_blank"
              rel="noopener nofollow"
              className="relative group overflow-hidden rounded-2xl h-full min-h-[190px] cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Oversized%20cream%20knit%20hoodie%20draped%20over%20vintage%20leather%20armchair%2C%20cozy%20reading%20nook%20with%20warm%20lamp%20light%2C%20autumn%20mood%2C%20lifestyle%20interior%20photography%2C%20soft%20textures%2C%20inviting%20atmosphere&width=900&height=600&seq=gallery-hoodies-v5&orientation=landscape"
                alt="Hoodies pandabuyspreadsheet category"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-label tracking-wider">
                  Hoodies/Sweaters
                </span>
                <p className="mt-2 text-background-50/90 text-xs leading-relaxed max-w-xs">
                  Oversized hoodies, knit sweaters, and cozy streetwear essentials
                </p>
              </div>
            </a>
            <a
              href={categories[9].url}
              target="_blank"
              rel="noopener nofollow"
              className="relative group overflow-hidden rounded-2xl h-full min-h-[190px] cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20watches%20and%20jewelry%20displayed%20on%20dark%20slate%20surface%20with%20golden%20accents%2C%20luxury%20accessories%20flat%20lay%2C%20soft%20dramatic%20lighting%2C%20sophisticated%20editorial%20photography%2C%20rich%20contrast%2C%20refined%20composition&width=900&height=600&seq=gallery-accessories-v5&orientation=landscape"
                alt="Accessories pandabuyspreadsheet category"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-label tracking-wider">
                  Accessories
                </span>
                <p className="mt-2 text-background-50/90 text-xs leading-relaxed max-w-xs">
                  Watches, jewelry, sunglasses, and finishing touches for every outfit
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}